import { SIGNALR_HUB_URL } from './env-consts'

// Утилита для получения URL SignalR хаба
export const getSignalRHubUrl = (hubName: string): string => {
  return `${SIGNALR_HUB_URL}/${hubName}`
}

// Константы для хабов
export const SIGNALR_HUBS = {
  FEEDBACKS: 'chat',
} as const

export const SIGNALR_EVENTS = {
  ON_NEW_MESSAGE: 'onNewMessage',
  ON_RADIO_ENDED: 'onRadioEnded',
  ON_RADIO_STARTED: 'onRadioStarted',
} as const
